/**
 * Wyciąga przetłumaczony komunikat z błędu API.
 * Jeśli błąd ma Code → tłumaczy przez t("nav.errors.KOD") (namespace admin).
 * Jeśli nie ma Code → zwraca generyczny komunikat.
 */
export const getBackendErrorMessage = (err: any, t: (key: string) => string): string => {
  try {
    const response = err && err.response;
    const data = response && response.data;
    const errors = data && data.Errors;

    if (!errors || errors.length === 0) return t("nav.operationError");

    const firstError = errors[0];

    // Nowy format: { Code, Message }
    if (firstError && firstError.Code) {
      const key = "nav.errors." + firstError.Code;
      const translated = t(key);
      // i18next zwraca klucz jeśli nie znaleziono tłumaczenia
      if (translated !== key) return translated;
      const fallback = firstError.Message || firstError.ErrorMessage;
      return fallback ? fallback : t("nav.operationError");
    }

    // Stary format ValidationError: { PropertyName, ErrorMessage }
    if (firstError && firstError.ErrorMessage) {
      return firstError.ErrorMessage;
    }

    // Stary format: plain string
    if (typeof firstError === "string") {
      return firstError;
    }

    return t("nav.operationError");
  } catch (e) {
    return t("nav.operationError");
  }
};
